import React, { useState } from "react";
import { Controller } from "react-hook-form";
import _ from "lodash";
import { IoEyeSharp } from "react-icons/io5";
import { IoIosEyeOff } from "react-icons/io";

// React-Hook-Form Input Field
export const InputField = React.forwardRef((props, ref) => {
  const { title, errors, defaultValue, isDisabled = false, ...others } = props;
  const [type, setType] = useState(others?.type);
  let err = _.get(errors, props.name);
  return (
    <div className="w-full text-start">
      <div
        className={`pointer-events-none font-normal mb-2 ${
          props?.rules && err ? "text-red-600" : "text-gray-600"
        }`}
      >
        {title}
        {props?.rules?.required?.value === true && (
          <span className="text-red-500 p-2">*</span>
        )}
      </div>
      <div
        className={`${
          props?.height ? props.height : "h-[35px]"
        } px-3 py-1 relative w-full border border-gray-300 bg-white focus-within:bg-white outlineStyle rounded ${
          props?.rules && err
            ? "focus-within:border-red-600 border-red-600"
            : "focus-within:border-teal-c-900"
        }`}
      >
        <Controller
          name={props?.name}
          control={props?.control}
          rules={props?.rules}
          defaultValue={defaultValue ?? ""}
          render={({ field }) => (
            <>
              <input
                {...props}
                {...field}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  if (props.onChange) {
                    props.onChange(e, props?.name);
                  }
                }}
                min={props.min}
                disabled={isDisabled}
                placeholder={props.placeholder ? props.placeholder : ""}
                value={field.value}
                className={`block w-full appearance-none focus:outline-none bg-transparent focus:ring-0 text-base font-light text-black-300 ${
                  isDisabled && "!bg-gray-100 text-gray-500 cursor-not-allowed"
                }`}
                {...others}
                type={type}
              />
              {others?.type == "password" && (
                <div
                  onClick={() => {
                    if (type == "text") {
                      setType("password");
                    } else setType("text");
                  }}
                  className="absolute top-2.5 right-3 cursor-pointer"
                >
                  {type == "text" ? <IoIosEyeOff /> : <IoEyeSharp />}
                </div>
              )}
            </>
          )}
        />
      </div>
      {props.rules && err && err?.message && (
        <p className=" text-xs text-red-600 h-3" id="email-error">
          {props.rules && err && props.rules && err?.message}
        </p>
      )}
    </div>
  );
});

// Simple Input Field
export const SimpleInputFiled = (props) => {
  const { title, isDisabled = false, onChange, ...others } = props;

  return (
    <div className="w-full">
      <div className={`pointer-events-none font-semibold mb-2 text-gray-600`}>
        {title}
      </div>
      <div
        className={`${
          props?.height ? props.height : "h-[35px]"
        } px-3 py-1 relative w-full border border-gray-300 bg-white focus-within:bg-white outlineStyle rounded`}
      >
        <input
          className={`block w-full appearance-none focus:outline-none bg-transparent focus:ring-0 text-base font-light text-black-300 ${
            isDisabled && "bg-gray-50 cursor-not-allowed"
          }`}
          disabled={isDisabled}
          onChange={(e) => {
            onChange(e?.target?.value, props.name);
          }}
          {...others}
        />
      </div>
    </div>
  );
};

export const SimpleRichFiled = (props) => {
  const { title, isDisabled = false, onChange, ...others } = props;

  return (
    <div className="w-full">
      <div className={`pointer-events-none font-normal mb-2 text-gray-600`}>
        {title}
      </div>
      <div
        className={`${
          props?.height ? props?.height : "h-[40.5px]"
        } px-3 py-2 relative w-full border border-gray-300 bg-white focus-within:bg-white outlineStyle`}
      >
        <textarea
          className={`block w-full appearance-none focus:outline-none bg-transparent focus:ring-0 text-base font-light text-black-300 ${
            isDisabled && "bg-gray-50 cursor-not-allowed"
          }`}
          disabled={isDisabled}
          onChange={(e) => {
            onChange(e?.target?.value, props.name);
          }}
          {...others}
        />
      </div>
    </div>
  );
};
